
<div *ngIf="banner?.banners?.length > 0" class="reto-container">
  <div class="reto-card">

    <div class="reto-content-top">
      <div class="reto-icon">
        <ion-icon name="sparkles-outline"></ion-icon>
      </div>
      <div class="reto-texts">
        <span class="reto-subtitle">RETO DISPONIBLE</span>
        <h3 class="reto-title">Multiplica tus tickets</h3>
        <p class="reto-description">
          Actualiza tus datos y multiplica tus tickets en el concurso de actualización de datos.
        </p>
      </div>
    </div>

    <div class="reto-actions">
      <ion-button fill="clear" class="btn-ahora-no" (click)="onGoBackClick()">AHORA NO</ion-button>

      <ion-button class="btn-acepto" (click)="onUpdateDataClick()">
          ACEPTO EL RETO
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-button>
    </div>

  </div>
</div>

<div class="ion-text-center" *ngIf="contestStores.length > 0">
  <ion-button fill="clear" (click)="openStoresModal()">Ver tiendas participantes</ion-button>
</div>
